import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.333 5.667a2.333 2.333 0 1 0 0 4.666 2.333 2.333 0 0 0 0-4.666m0 3.333a1 1 0 1 1 0-2 1 1 0 0 1 0 2m5.334-5.667H5.333a4.667 4.667 0 0 0 0 9.334h5.334a4.667 4.667 0 0 0 0-9.334m0 8H5.333a3.333 3.333 0 1 1 0-6.666h5.334a3.334 3.334 0 0 1 0 6.666"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })